<template>

    <b-modal id="my-quizzes-game-category-modal" centered>
        <template #modal-title>{{ t.__('Edytuj kategorię') }}</template>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <legend>{{ t.__('Ikona') }}</legend>
                    <file-manager-image-select :input-name="'icon'" :value="form.icon" v-model="form.icon" :mime-types="'image/gif,image/jpeg,image/png,image/tiff,image/bmp,image/x-xbitmap'" :crop-available="true" :crop-aspect-ratio="240/240" :width="300"></file-manager-image-select>
                </div>
            </div>
            <div class="col-md-8">

                <b-form-group
                    id="my-quizzes-add-set-display-name-group"
                    description=""
                    :label="t.__('Nazwa wyświetlana')"
                    valid-feedback=""
                    :invalid-feedback="form.errors.get('display_name')"
                    :state="form.errors.state('display_name')">
                    <b-form-input id="my-quizzes-add-set-display-name" v-model="form.display_name" :state="form.errors.state('display_name')" trim></b-form-input>
                </b-form-group>

            </div>
        </div>
        <template #modal-footer>
            <b-button variant="secondary" @click="close">{{ t.__('Anuluj') }}</b-button>
            <b-button variant="success" @click="save">{{ t.__('Zapisz') }}</b-button>
        </template>
    </b-modal>

</template>

<script>

import {inputValidators} from '../mixins/inputValidators';

export default {

    name: 'MyQuizzesGameCategoryModal',

    mixins: [inputValidators],

    data() {
        return {
            eventHub: window.eventHub,
            form: new Vue.prototype.Form({
                identifier: null,
                icon: null,
                display_name: null
            })
        }
    },

    computed: {

    },

    beforeMount() {

        this.eventHub.$on('my-quizzes-game-edit-category', (category) => {
            this.form.setData({
                identifier: category.identifier,
                icon: category.icon,
                display_name: category.display_name,
            });
            this.$bvModal.show('my-quizzes-game-category-modal')
        });

        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if (modalId === 'my-quizzes-game-category-modal') {
                this.form.setData({
                    identifier: null,
                    icon: null,
                    display_name: null
                });
            }
        });

    },

    methods:  {

        close() {
            this.$bvModal.hide('my-quizzes-game-category-modal');
        },

        save() {
            this.eventHub.$emit('my-quizzes-update-edit-category', this.form);
            this.close();
        }

    }

}

</script>

<style scoped>

</style>
